
import { useEffect } from "react";
import { useState } from "react";
import React from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useAuthHeader } from "../../auth/AuthService";
import { useTranslation } from "react-i18next";
import { retrieveUserDisplayStatistic, retrieveUserIcsxStatistic } from "../../Services/Admin/UserApiService";
import { Badge } from "primereact/badge";
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { useContext } from "react";
import { LayoutContext } from "../../Layouts/Admin/layoutcontext";

export default function UserStatistic() {

    const {t, i18n} = useTranslation();
    const authHeader = useAuthHeader();
    const [loading, setLoading] = useState(false);
    const [userIcsx, setUserIcsx] = useState([]);
    const [userDisplay, setUserDisplay] = useState([]);

    const { setMenuTitle } = useContext(LayoutContext);
    useEffect(() => {
        setMenuTitle('Users\' Statistic');
    },[]);

    useEffect(() => {
        getUserIcsxStatistic()
        getUserDisplayStatistic()
    }, []);

    const getUserIcsxStatistic = async () => {
        setLoading(true);
        await retrieveUserIcsxStatistic(authHeader())
        .then((response) => {
            setUserIcsx(response?.data?.data);
            setLoading(false);
        })
        .catch((error) => console.log(error));
    }

    const getUserDisplayStatistic = async () => {
        setLoading(true);
        await retrieveUserDisplayStatistic(authHeader())
        .then((response) => {
            setUserDisplay(response?.data?.data);
            setLoading(false);
        })
        .catch((error) => console.log(error));
    }

    const countBodyTemplate = (rowData) => {
        return <Badge value={rowData?.count} severity="info"></Badge>
    }

    const oneStockBodyTemplate = (rowData) => {
        return <Badge value={rowData?.oneStockCount} severity="info"></Badge>
    }

    const allStockBodyTemplate = (rowData) => {
        return <Badge value={rowData?.allStockCount} severity="info"></Badge>
    }

    const headerGroup = (
        <ColumnGroup >
            <Row>
                <Column align="center" header={t("User Type")} rowSpan={2} />
                <Column align="center" header={t("#Users")} colSpan={2} />
            </Row>
            <Row>
                <Column align="center" header={t("All Stock")}/>
                <Column align="center" header={t("One Stock")}/>
            </Row>
        </ColumnGroup>
    );

    const footerGroup = (
        <ColumnGroup>
            <Row>
                <Column footer="Sub Total"/>
                <Column footer={<Badge value={userDisplay.reduce((accumulator, object) =>  accumulator + object.allStockCount, 0)} severity="info"></Badge>} align={'right'}/>
                <Column footer={<Badge value={userDisplay.reduce((accumulator, object) =>  accumulator + object.oneStockCount, 0)} severity="info"></Badge>} align={'right'}/>
            </Row>
            <Row>
                <Column footer={t("Total")}/>
                <Column footer={<Badge value={userDisplay.reduce((accumulator, object) =>  accumulator + object.allStockCount + object.oneStockCount, 0)} severity="info"></Badge>} align={'center'} colSpan={2}/>
            </Row>
        </ColumnGroup>
    );
    
    return (
        <div className="grid">
            <div className="col-12 md:col-6">
                <div className="card">
                    <p className="text-xl font-bold text-700 text-center">ICSX Users'statistic</p>
                    <DataTable value={userIcsx} 
                            loading={loading}
                            showGridlines 
                    >
                        <Column field="firm" header={t("Firm")}></Column>
                        <Column field="count" align={"right"} body={countBodyTemplate} header={t("#Users")} ></Column>
                    </DataTable>
                </div>
            </div>
            <div className="col-12 md:col-6">
                <div className="card">
                    <p className="text-xl font-bold text-700 text-center">Data Display Users'statistic</p>
                    <DataTable value={userDisplay} 
                            loading={loading}
                            headerColumnGroup={headerGroup}
                            footerColumnGroup={footerGroup}
                            showGridlines 
                    >
                        <Column field="userType" header="User Type"></Column>
                        <Column field="allStockCount" align={"right"} body={allStockBodyTemplate} header="All Stock" ></Column>
                        <Column field="oneStockCount" align={"right"} body={oneStockBodyTemplate} header="One Stock" ></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    )
}